import { escape, unescape } from 'lodash';
import PropTypes from 'prop-types';
import { omit, pipe } from 'ramda';
import React, { PureComponent } from 'react';

const createMarkup = (html) => ({ __html: html });

class HtmlText extends PureComponent {
  static propTypes = {
    html: PropTypes.string.isRequired,
    stopPropagation: PropTypes.bool,
    escape: PropTypes.bool,
    _ref: PropTypes.func,
  };

  static defaultProps = {
    stopPropagation: false,
    escape: false,
    _ref: () => null,
  };

  setRef = (node) => {
    this.node = node;
    this.props._ref(node);
  };

  handleClickPropagation = (e) => {
    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  };

  get html() {
    return this.props.escape ? pipe(unescape, escape)(this.props.html) : this.props.html;
  }

  render() {
    const props = omit(['html', '_ref', 'stopPropagation', 'escape'], this.props);
    return (
      <span
        {...props}
        onClick={this.handleClickPropagation}
        dangerouslySetInnerHTML={createMarkup(this.html)}
        ref={this.setRef}
      />
    );
  }
}

export default HtmlText;
